module.exports = __webpack_public_path__ + "static/img/yunR3.cfec60a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/background/yunR3.png
// module id = 88mL
// module chunks = 1